var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-color-picker',{staticStyle:{"margin":"auto"},attrs:{"flat":"","dot-size":"8","hide-canvas":"","hide-inputs":"","hide-mode-switch":""},on:{"update:color":function($event){return _vm.update($event)}},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }